import { render, staticRenderFns } from "./SelectProduct.vue?vue&type=template&id=5bea19fd&scoped=true&"
import script from "./SelectProduct.vue?vue&type=script&lang=js&"
export * from "./SelectProduct.vue?vue&type=script&lang=js&"
import style0 from "./SelectProduct.vue?vue&type=style&index=0&id=5bea19fd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bea19fd",
  null
  
)

export default component.exports